export default "__VITE_ASSET__BatlKfI9__"